import { useEffect } from 'react';
import { getApiBaseURL } from '../utils/api';
import { safeSessionStorage } from '../utils/safeStorage';

/**
 * 페이지 경로 변경 시 방문 기록(유입 리퍼러 포함)을 서버에 전송합니다.
 * @param {string} pathname
 * @param {string} [search]
 */
export function useVisitorTracking(pathname, search = '') {
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        let sessionId = safeSessionStorage.getItem('session_id');
        if (!sessionId) {
          sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          safeSessionStorage.setItem('session_id', sessionId);
        }

        const attributionKey = 'visitor_first_attribution';
        let refPayload = null;
        try {
          refPayload = JSON.parse(safeSessionStorage.getItem(attributionKey) || 'null');
        } catch {
          refPayload = null;
        }

        // document.referrer는 SPA 이동 후에도 최초 값일 수 있습니다. 세션 최초 한 번만
        // 판별하고 UTM을 함께 보존해 모든 페이지뷰가 같은 유입 세션으로 귀속되게 합니다.
        if (!refPayload) {
          const ref = typeof document !== 'undefined' && document.referrer ? document.referrer.trim() : '';
          refPayload = { referrer: '', referrer_type: 'none' };
          if (ref) {
          try {
            const refUrl = new URL(ref);
            const here = new URL(window.location.href);
            refPayload =
              refUrl.origin === here.origin
                ? { referrer: ref.slice(0, 500), referrer_type: 'same_origin' }
                : { referrer: ref.slice(0, 500), referrer_type: 'cross_origin' };
          } catch {
            refPayload = { referrer: ref.slice(0, 500), referrer_type: 'cross_origin' };
          }
          }
          const params = new URLSearchParams(search || window.location.search || '');
          refPayload = {
            ...refPayload,
            utm_source: (params.get('utm_source') || '').slice(0, 120),
            utm_medium: (params.get('utm_medium') || '').slice(0, 120),
            utm_campaign: (params.get('utm_campaign') || '').slice(0, 200),
            landing_page: `${pathname}${search || ''}`.slice(0, 500),
          };
          safeSessionStorage.setItem(attributionKey, JSON.stringify(refPayload));
        }

        await fetch(`${getApiBaseURL()}/api/visitor/track`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_path: `${pathname}${search || ''}`,
            session_id: sessionId,
            ...refPayload,
          }),
        });
      } catch (error) {
        console.error('방문자 추적 오류:', error);
      }
    };

    trackVisitor();
  }, [pathname, search]);
}
